import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="searchable-select"
export default class extends Controller {
  static targets = ["input", "dropdown", "hiddenType", "hiddenId", "option"]
  static values = {
    placeholder: { type: String, default: "Search..." }
  }

  connect() {
    this.selectedValue = null
    this.selectedText = null

    // Set initial value if present
    if (this.hiddenTypeTarget.value && this.hiddenIdTarget.value) {
      const selectedOption = this.optionTargets.find(
        opt => opt.dataset.type === this.hiddenTypeTarget.value &&
               opt.dataset.id === this.hiddenIdTarget.value.toString()
      )
      if (selectedOption) {
        // Don't call selectOption as it would close dropdown, just update display
        const displayButton = this.element.querySelector('[data-action*="toggleDropdown"]')
        const displayText = displayButton?.querySelector('.selected-text')
        if (displayText && selectedOption.dataset.text) {
          displayText.textContent = selectedOption.dataset.text
          displayText.classList.remove('text-gray-400')
          displayText.classList.add('text-gray-900')
        }
      }
    }

    // Close dropdown when clicking outside
    this.boundCloseDropdown = this.closeDropdown.bind(this)
    document.addEventListener('click', this.boundCloseDropdown)
  }

  disconnect() {
    document.removeEventListener('click', this.boundCloseDropdown)
  }

  toggleDropdown(event) {
    event.stopPropagation()
    this.dropdownTarget.classList.toggle('hidden')
    if (!this.dropdownTarget.classList.contains('hidden')) {
      this.inputTarget.focus()
    }
  }

  closeDropdown(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add('hidden')
      this.clearSearch()
    }
  }

  preventClose(event) {
    event.stopPropagation()
  }

  search(event) {
    const query = event.target.value.toLowerCase()

    this.optionTargets.forEach(option => {
      const text = option.textContent.toLowerCase()
      const group = option.closest('[data-group]')

      if (text.includes(query)) {
        option.classList.remove('hidden')
        if (group) group.classList.remove('hidden')
      } else {
        option.classList.add('hidden')
      }
    })

    // Hide groups if all their options are hidden
    const groups = this.element.querySelectorAll('[data-group]')
    groups.forEach(group => {
      const visibleOptions = group.querySelectorAll('[data-searchable-select-target="option"]:not(.hidden)')
      if (visibleOptions.length === 0) {
        group.classList.add('hidden')
      }
    })
  }

  selectOption(option) {
    const type = option.dataset.type
    const id = option.dataset.id
    const text = option.dataset.text

    this.hiddenTypeTarget.value = type
    this.hiddenIdTarget.value = id
    this.selectedValue = `${type}-${id}`
    this.selectedText = text

    // Update the display button
    const displayButton = this.element.querySelector('[data-action*="toggleDropdown"]')
    const displayText = displayButton.querySelector('.selected-text')
    if (displayText) {
      displayText.textContent = text
      displayText.classList.remove('text-gray-400')
      displayText.classList.add('text-gray-900')
    }

    this.dropdownTarget.classList.add('hidden')
    this.clearSearch()
  }

  select(event) {
    event.preventDefault()
    const option = event.currentTarget
    this.selectOption(option)
  }

  clear(event) {
    event.preventDefault()
    event.stopPropagation()

    this.hiddenTypeTarget.value = ''
    this.hiddenIdTarget.value = ''
    this.selectedValue = null
    this.selectedText = null

    // Update the display button
    const displayButton = this.element.querySelector('[data-action*="toggleDropdown"]')
    const displayText = displayButton.querySelector('.selected-text')
    if (displayText) {
      displayText.textContent = t('javascript.controllers.searchable_select_controller.no_owner')
      displayText.classList.remove('text-gray-900')
      displayText.classList.add('text-gray-400')
    }

    this.dropdownTarget.classList.add('hidden')
    this.clearSearch()
  }

  clearSearch() {
    this.inputTarget.value = ''
    this.optionTargets.forEach(option => option.classList.remove('hidden'))
    const groups = this.element.querySelectorAll('[data-group]')
    groups.forEach(group => group.classList.remove('hidden'))
  }
}

